import React from 'react'

import { WeatherIconProps } from './cloudy'

export const PartlyRainy = ({ x = 0, y = 0 }: WeatherIconProps) => (
  <svg
    width="27"
    height="27"
    viewBox={`${x} ${y} 27 27`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="27" height="27" />
    <path
      d="M7.40112 8.46176C5.91767 9.73602 5.91849 12.4372 7.21053 13.9474C7.7569 13.7301 8.78948 11.8421 9.84211 12.3684C10.0882 8.83932 12.317 9.46401 12.4736 8.83932C11.1815 7.37628 8.88458 7.18751 7.40112 8.46176Z"
      fill="#FFD463"
    />
    <path
      d="M4.83055 8.11701L3.67435 7.62744"
      stroke="#FFD463"
      strokeWidth="1.3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7087 6.06815L11.0941 5"
      stroke="#FFD463"
      strokeWidth="1.3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.20438 11.4556L3 11.5891"
      stroke="#FFD463"
      strokeWidth="1.3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.28726 6.06815L6.80551 5"
      stroke="#FFD463"
      strokeWidth="1.3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3816 11.3158C21.0138 11.3158 22.3421 12.591 22.3421 14.1579C22.3421 15.1805 22.1967 16.0788 21.642 16.5795C21.275 17.1391 21.806 17.093 22.1174 17C22.7612 16.3709 23 15.3315 23 14.1579C23 12.2423 21.377 10.6842 19.3816 10.6842C19.1099 10.6842 18.8329 10.7196 18.5408 10.791C17.7105 9.18295 16.0059 8.1579 14.1184 8.1579C11.7118 8.1579 9.66053 9.83474 9.25855 12.092C8.0421 12.4691 7.21053 13.5491 7.21053 14.7895C7.21053 16.3564 8.53881 17.6316 10.1711 17.6316C10.3526 17.6316 10.5 17.4901 10.5 17.3158C10.5 17.1415 10.3526 17 10.1711 17C8.90131 17 7.86842 16.0084 7.86842 14.7895C7.86842 13.7695 8.59276 12.8884 9.63026 12.6472C9.76316 12.6168 9.8625 12.5101 9.8796 12.38C10.1467 10.3331 11.9691 8.78948 14.1184 8.78948C15.8395 8.78948 17.3855 9.77285 18.0579 11.2943C18.1243 11.4453 18.2993 11.523 18.4632 11.4712C18.7941 11.367 19.0947 11.3158 19.3816 11.3158Z"
      fill="#BFBFBF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.642 16.5795C22.1967 16.0788 22.3421 15.1805 22.3421 14.1579C22.3421 12.5909 21.0138 11.3158 19.3816 11.3158C19.0947 11.3158 18.7941 11.3669 18.4632 11.4711C18.2993 11.5229 18.1243 11.4453 18.0579 11.2943C17.3855 9.77283 15.8395 8.78946 14.1184 8.78946C11.9691 8.78946 10.1467 10.333 9.87961 12.38C9.8625 12.5101 9.76316 12.6168 9.63027 12.6471C8.59277 12.8884 7.86842 13.7695 7.86842 14.7895C7.86842 16.0084 8.90132 17 10.1711 17C10.3526 17 10.5 17.1415 10.5 17.3158C10.5 17.4901 10.3526 17.6316 10.1711 17.6316C8.53882 17.6316 7.21053 16.3564 7.21053 14.7895C7.21053 13.549 8.04211 12.469 9.25855 12.092C9.66053 9.83473 11.7118 8.15789 14.1184 8.15789C16.0059 8.15789 17.7105 9.18294 18.5408 10.7909C18.8329 10.7196 19.1099 10.6842 19.3816 10.6842C21.377 10.6842 23 12.2423 23 14.1579C23 15.3315 22.7612 16.3708 22.1174 17C21.806 17.093 21.275 17.1391 21.642 16.5795ZM18.6451 10.5624C17.755 8.9646 16.0241 7.95789 14.1184 7.95789C11.6621 7.95789 9.55328 9.6412 9.08419 11.939C7.85167 12.3716 7.01053 13.496 7.01053 14.7895C7.01053 16.4745 8.43613 17.8316 10.1711 17.8316C10.4553 17.8316 10.7 17.6082 10.7 17.3158C10.7 17.0234 10.4553 16.8 10.1711 16.8C9.004 16.8 8.06842 15.8903 8.06842 14.7895C8.06842 13.8683 8.72281 13.0636 9.67528 12.842C9.88566 12.7938 10.0494 12.6227 10.0779 12.4061L10.0779 12.4059C10.3312 10.4647 12.0632 8.98946 14.1184 8.98946C15.7638 8.98946 17.236 9.92927 17.875 11.3751C17.9843 11.6231 18.2662 11.7431 18.5232 11.6619C18.8388 11.5625 19.119 11.5158 19.3816 11.5158C20.9111 11.5158 22.1421 12.709 22.1421 14.1579C22.1421 14.6617 22.1061 15.1231 22.0063 15.515C21.9066 15.9064 21.7466 16.2157 21.508 16.4311L21.4889 16.4483L21.4748 16.4698C21.3772 16.6186 21.3121 16.765 21.3179 16.9027C21.321 16.9778 21.3454 17.0494 21.3938 17.1091C21.4406 17.1667 21.5001 17.2013 21.5556 17.2219C21.6611 17.2612 21.7815 17.2609 21.8798 17.2513C21.9831 17.2411 22.0875 17.2177 22.1746 17.1916L22.2219 17.1775L22.2572 17.143C22.9603 16.4559 23.2 15.3467 23.2 14.1579C23.2 12.1242 21.4797 10.4842 19.3816 10.4842C19.1403 10.4842 18.8967 10.5104 18.6451 10.5624Z"
      fill="#BFBFBF"
    />
    <path
      d="M13.2091 16.726C13.2904 16.3198 13.027 15.9247 12.6208 15.8435C12.2146 15.7622 11.8195 16.0257 11.7383 16.4318L13.2091 16.726ZM10.6856 21.695C10.6044 22.1012 10.8678 22.4963 11.274 22.5775C11.6801 22.6587 12.0753 22.3953 12.1565 21.9892L10.6856 21.695ZM11.7383 16.4318L10.6856 21.695L12.1565 21.9892L13.2091 16.726L11.7383 16.4318Z"
      fill="#6EC6E9"
    />
    <path
      d="M16.2602 16.6998C16.3402 16.2933 16.0755 15.899 15.6691 15.8191C15.2627 15.7391 14.8684 16.0037 14.7884 16.4101L16.2602 16.6998ZM13.9504 20.6686C13.8704 21.075 14.1351 21.4693 14.5415 21.5493C14.9479 21.6293 15.3422 21.3646 15.4222 20.9582L13.9504 20.6686ZM14.7884 16.4101L13.9504 20.6686L15.4222 20.9582L16.2602 16.6998L14.7884 16.4101Z"
      fill="#6EC6E9"
    />
    <path
      d="M19.5249 16.726C19.6062 16.3198 19.3428 15.9247 18.9366 15.8435C18.5304 15.7622 18.1353 16.0257 18.0541 16.4318L19.5249 16.726ZM17.0014 21.695C16.9202 22.1012 17.1836 22.4963 17.5898 22.5775C17.9959 22.6587 18.3911 22.3953 18.4723 21.9892L17.0014 21.695ZM18.0541 16.4318L17.0014 21.695L18.4723 21.9892L19.5249 16.726L18.0541 16.4318Z"
      fill="#6EC6E9"
    />
  </svg>
)
